module.exports = __webpack_public_path__ + "static/img/logo-xs.10512d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-xs.png
// module id = 284
// module chunks = 1